import {faSpinner, faCheckCircle, faBan} from '@fortawesome/free-solid-svg-icons';

export const ActionStatus = [
  { name: "pending", icon: faSpinner, color: 'primary', additionalClasses: 'fa-spin' },
  { name: "done", icon: faCheckCircle, color: 'success', additionalClasses: '' },
  { name: "error", icon: faBan, color: 'danger', additionalClasses: '' },
  { name: "cancelled", icon: faBan, color: 'warning', additionalClasses: '' }
]

export function genId() {
  return Math.random().toString(36).substring(8);
}
